<template>
  <div
    class="flex transition duration-500 ease-in-out"
    :class="{
      'bg-blue-700 hover:bg-blue-700': active && authStore.isPortal,
      'bg-gray-300 hover:bg-gray-300': active && !authStore.isPortal,
      'text-white hover:bg-blue-700': authStore.isPortal,
      'hover:bg-gray-300': !authStore.isPortal
    }"
  >
    <div class="flex transition duration-500 ease-in-out transform">
      <div class="p-1 mr-4">
        <i class="fal fa-fw" :class="icon" />
      </div>
      <div class="flex flex-col justify-around">{{ label }}</div>
    </div>
  </div>
</template>

<script>
import { mapStores } from 'pinia'
import { useAuthStore } from '@/pinia/auth'

export default {
  props: ['icon', 'label', 'active'],
  computed: {
    ...mapStores(useAuthStore)
  }
}
</script>
